<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import "style/font/font.css";

#app {
	font-family: OppO_R;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1F2329;
  font-size: 16px;
}
html::-webkit-scrollbar { display: none; }
body::-webkit-scrollbar{
  display: none;
}	
*{
	margin: 0px;
	padding: 0px;
}
a{
	text-decoration:none;
}
div{
	box-sizing: border-box;
}

.textl{
	text-align: left;
}
img{
	width: 100%;
	height: 100%;
	vertical-align: middle;
}
input{
	margin: 0px;
	padding: 0px;
	border: none;
}
.dfc{
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}
.dfs{
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
}
.dfb{
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}
.fs18{
	font-size: 18px;
}
.mr10{
	margin-right: 10px;
}
.mr20{
	margin-right: 20px;
}
.mr30{
	margin-right: 30px;
}
.mr40{
	margin-right: 40px;
}
.mr50{
	margin-right: 50px;
}
.mr60{
	margin-right: 60px;
}
.mr70{
	margin-right: 70px;
}
.mr80{
	margin-right: 80px;
}
.mr66{
	margin-right: 66px;
}
.mr100{
	margin-right: 100px;
}
.mb4{
	margin-bottom: 4px;
}
.mb10{
	margin-bottom: 10px;
}
.mb20{
	margin-bottom: 20px;
}
.mb30{
	margin-bottom: 30px;
}
.mb40{
	margin-bottom: 40px;
}
.mb60{
	margin-bottom: 60px;
}
.mb70{
	margin-bottom: 70px;
}
.mb80{
	margin-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue